import { useContext, useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import AsyncSelect from 'react-select/async'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'
import Box from '../../../../Global/Box'
import InputController from '../../../../Global/InputController'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { GET_ALL_USERS_APP_SEARCH } from '../../../../../graphql/Catalog/UsersApp/userApp'
import {
  GET_USER,
  GET_USER_BY_NAME_PHONE_ADDRESS,
  VALID_ALREADY_EXIST_USER,
} from '../../../../../graphql/Catalog/Users/user'
import { AuthContext } from '../../../../../Auth/AuthContext'
import { objNameRoles } from '../../../../../const/constRoles'

const StepCitizen = ({
  refWizard,
  setIsValidSteps,
  data,
  setData,
  setUserFound = () => {},
  userFound,
  formToQualify = false,
  setFormToQualify = () => {},
}) => {
  const { user } = useContext(AuthContext)

  const isAttentionCitizenOrMasterOrAdmin = [
    objNameRoles.atencion_ciudadana,
    objNameRoles.master,
    objNameRoles.admin,
  ].includes(user?.role)

  const { showLoading, hideLoading } = useLoading()

  //STATES
  const [selectedUser, setSelectedUser] = useState(null)
  const [userFoundType, setUserFoundType] = useState({
    isGestor: false,
    isAnonymous: false,
  })

  //MUTATIONS
  const [getSearchUsersApp] = useMutation(GET_ALL_USERS_APP_SEARCH)
  const [getSearchUser] = useMutation(GET_USER)
  const [getSearchUserAnonymous] = useMutation(GET_USER_BY_NAME_PHONE_ADDRESS)

  const [validAleadyExistUser] = useMutation(VALID_ALREADY_EXIST_USER)

  //------ Yup schema -----
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Campo requerido'),
    phone: Yup.string()
      .trim()
      .matches(/^\d{10}$/, 'El teléfono debe tener 10 dígitos')
      .required('El teléfono es requerido'),
    address: Yup.string().required('La dirección es requerida'),
  })

  const validationSchemaUserFound = Yup.object().shape({
    name: Yup.string().required('Campo requerido'),
    phone: Yup.string()
      .trim()
      .matches(/^\d{10}$/, 'El teléfono debe tener 10 dígitos'),
    address: Yup.string(),
  })

  const [schemaValidator, setSchemaValidator] = useState(validationSchema)

  //------ Yup form -----
  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(schemaValidator),
  })

  //USEEFFECT FOR CHANGE TO NEXT TAB IF IS FORM TO QUALIFY
  useEffect(() => {
    if (formToQualify && !data) {
      refWizard.current?.nextTab()
      setData({
        formToQualify: true,
      })
    }

    if (formToQualify && data) {
      setData(null)
      setFormToQualify(false)
    }

    if (!formToQualify && data) {
      setData(null)
    }
  }, [formToQualify])

  //FUNCTIONS
  const onSubmit = async (Data) => {
    showLoading()
    try {
      // if (!Data.id_user_app || Data.id_user_app === '') {
      //   await validAleadyExistUser({
      //     variables: {
      //       input: {
      //         type_user: 'app',
      //         email: Data.email,
      //       },
      //     },
      //   })
      // }

      setData(Data)
      setIsValidSteps((old) => ({ ...old, step1: true }))
      refWizard.current?.nextTab()
      return
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleClean = () => {
    reset({
      id_user_app: '',
      id_user_gestor: '',
      name: '',
      email: '',
      isGestor: false,
      isAnonymous: false,
    })
    setData(null)
    setIsValidSteps((old) => ({ ...old, step1: false }))
    setSelectedUser(null)
    setUserFound(false)
    setSchemaValidator(validationSchema)
    setUserFoundType({
      isGestor: false,
      isAnonymous: false,
    })
  }

  const handleSelectedUser = (selected) => {
    if (selected) {
      reset({
        id_user_app: selected.id,
        name: selected?.name ?? '',
        email: selected?.email ?? '',
        phone: selected?.phone ?? '',
        address: selected?.address ?? '',
        isGestor: false,
        isAnonymous: false,
      })
      setUserFound(true)
      setSchemaValidator(validationSchemaUserFound)
      return setSelectedUser(selected)
    } else {
      handleClean()
    }
  }

  const searchUsers = async (search) => {
    const { data } = await getSearchUsersApp({
      variables: { search },
    })
    return data.getAllUserAppBySearch.map((item) => ({
      value: item.id,
      label: item.name,
      ...item,
    }))
  }

  const loadUsersOptions = async (search, callback) => {
    if (search.length > 2) {
      await callback(await searchUsers(search))
    } else callback([])
  }

  //EFFECTS
  useEffect(() => {
    if (data) {
      reset(data)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleSearchUser = async (type) => {
    try {
      if (type === 'anonymus') {
        const { data } = await getSearchUserAnonymous({
          variables: {
            name: 'Anónimo',
            phone: '0000000000',
            address: 'conocido',
            type_user: 'web',
          },
        })
        if (data.getUserByNamePhoneAddress) {
          reset({
            id_user_app: data.getUserByNamePhoneAddress?.id ?? '',
            name: data.getUserByNamePhoneAddress?.name ?? '',
            email: data.getUserByNamePhoneAddress?.email ?? '',
            phone: data.getUserByNamePhoneAddress?.phone ?? '',
            address: data.getUserByNamePhoneAddress?.address ?? '',
            isGestor: false,
            isAnonymous: true,
          })
          setUserFound(true)
          setUserFoundType({
            isGestor: false,
            isAnonymous: true,
          })
          return setSchemaValidator(validationSchemaUserFound)
        } else {
          handleClean()
          return toastSweetAlert({
            mode: 'error',
            message: 'No se encontró información del anónimo',
          })
        }
      } else if (type === 'myInfo') {
        const { data } = await getSearchUser({
          variables: { userId: user?.idUser },
        })
        if (data.getUser) {
          reset({
            id_user_app: user?.idUser ?? '',
            name: data.getUser?.name ?? '',
            email: data.getUser?.email ?? '',
            phone: data.getUser?.phone ?? '',
            address: data.getUser?.address ?? '',
            isGestor: true,
            isAnonymous: false,
          })
          setUserFound(true)
          setUserFoundType({
            isGestor: true,
            isAnonymous: false,
          })
          return setSchemaValidator(validationSchemaUserFound)
        } else {
          handleClean()
          return toastSweetAlert({
            mode: 'error',
            message: 'No se encontró información del usuario',
          })
        }
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          {/* <div className="col-12 col-sm-12 col-md-4">
                  <label htmlFor="">Buscar por email o nombre</label>
                  <AsyncSelect
                    loadOptions={loadUsersOptions}
                    isClearable
                    placeholder="Escribe..."
                    noOptionsMessage={() => 'Sin resultado'}
                    autoFocus
                    onChange={(e) => handleSelectedUser(e)}
                    value={selectedUser}
                    isDisabled={userFoundType.isGestor || userFoundType.isAnonymous}
                  />
                </div> */}
          {/* {user.role === objNameRoles.gestor_interno ||
                  user.role === objNameRoles.gestor_global_independiente ||
                  (user.role === objNameRoles.gestor_global && (
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-migrates btn-sm mt-5"
                        onClick={handleSearchUser}
                      >
                        Usar mi información
                      </button>
                    </div>
                  ))} */}
          <div className="col-12 mt-3 mb-3 buttons-search">
            <button
              type="button"
              className="btn btn-migrates-white btn-sm"
              onClick={() => handleSearchUser('myInfo')}
            >
              Usar mi información
            </button>
            <button
              type="button"
              className="btn btn-migrates-white btn-sm ml-2"
              onClick={() => handleSearchUser('anonymus')}
            >
              Reporte anónimo
            </button>
            {isAttentionCitizenOrMasterOrAdmin && (
              <button
                type="button"
                className="btn  btn-migrates-white btn-sm ml-2"
                onClick={() => setFormToQualify(true)}
              >
                Queja/Felicitación
              </button>
            )}
          </div>
        </div>
        {/* <div className="row">
                <div className="mb-3 col-sm-12 col-md-3">
                  <InputController
                    label="ID"
                    name="id_user_app"
                    type="text"
                    placeholder=""
                    control={control}
                    readOnly
                  />
                </div>
              </div> */}
        <div className="row">
          <div className="mb-3 col-sm-12 col-md-5">
            <InputController
              label="Nombre ciudadano"
              name="name"
              type="text"
              placeholder="nombre"
              control={control}
              readOnly={selectedUser ?? userFound}
            />
          </div>
          <div className="mb-3 col-sm-12 col-md-4">
            <InputController
              label="Teléfono"
              name="phone"
              type="text"
              placeholder="Teléfono"
              control={control}
              readOnly={selectedUser ?? userFound}
              maxLength={10}
            />
          </div>
          <div className="mb-3 col-sm-12 col-md-12">
            <InputController
              label="Dirección"
              name="address"
              type="text"
              placeholder="Dirección"
              control={control}
              readOnly={selectedUser ?? userFound}
            />
          </div>
        </div>

        <div className="row control-btn-box">
          <button className="btn btn-migrates w-20" type="submit">
            Siguiente <i className="fas fa-arrow-right ml-1" />
          </button>
          <span
            className="btn btn-migrates-white"
            onClick={() => handleClean()}
          >
            Limpiar
          </span>
        </div>

        {/* <Box
          title={`Datos del ciudadano`}
          classNameHeader="card-header py-1"
          btnSubmitText={
            <>
              Siguiente <i className="fas fa-arrow-right ml-1" />
            </>
          }
          btnSecondFunctionTitle="Limpiar"
          btnSecondFunction={() => handleClean()}
          errors={errors}
          btnSubmit={true}
          content={
            <>

            </>
          }
        /> */}
      </form>
    </FormProvider>
  )
}

export default StepCitizen
